import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    emptyTitle: {
      canceled: 'No transfer cancelled',
      done: 'No transfer executed',
      pending: 'No pending transfer',
      processing: 'No transfer in processing',
    },
  },
  fr: {
    emptyTitle: {
      canceled: 'Aucun virement annulés',
      done: 'Aucun virement exécuté',
      pending: 'Aucun virement en attente',
      processing: 'Aucun virement en cours de traitement',
    },
  },
} as const);

export default locales;
